import api from './api';
import { setContractAddress, setUsdcAddress, getContractAddress, getUsdcAddress } from './blockchain';
import { setNftRewardContractAddress, getNftRewardContractAddress } from './nftRewardChain';

/**
 * Align frontend contract/USDC with backend .env (required after redeploy).
 */
export async function syncChainConfigFromServer() {
  const { data } = await api.get('/config/blockchain');
  const contractAddress = data?.contractAddress || null;
  const usdcAddress = data?.usdcAddress || null;
  const nftRewardContractAddress = data?.nftRewardContractAddress || null;

  if (contractAddress) setContractAddress(contractAddress);
  if (usdcAddress) setUsdcAddress(usdcAddress);
  if (nftRewardContractAddress) setNftRewardContractAddress(nftRewardContractAddress);

  const envContract = process.env.REACT_APP_CONTRACT_ADDRESS;
  const envUsdc = process.env.REACT_APP_USDC_ADDRESS;
  if (
    envContract &&
    contractAddress &&
    String(envContract).toLowerCase() !== String(contractAddress).toLowerCase()
  ) {
    console.warn(
      '[WeRgame] REACT_APP_CONTRACT_ADDRESS differs from backend. Using backend:',
      contractAddress
    );
  }
  if (envUsdc && usdcAddress && String(envUsdc).toLowerCase() !== String(usdcAddress).toLowerCase()) {
    console.warn('[WeRgame] REACT_APP_USDC_ADDRESS differs from backend. Using backend:', usdcAddress);
  }

  return {
    contractAddress: getContractAddress(),
    usdcAddress: getUsdcAddress(),
    nftRewardContractAddress: getNftRewardContractAddress(),
    chainId: data?.chainId,
  };
}
